<div class="flex items-center justify-center w-full banner bg-center bg-cover" style="background-image: url({{this.catalogHeaderImage}});">
  <div class="flex flex-col p-4">
      <h1 [style.color]="headerTextColor" class="text-center md:text-6xl font-bold text-4xl max-sm:text-left">
        {{catalogHeaderTitle}}
      </h1>
      <h5 [style.color]="headerTextColor" class="text-left lg:text-3xl text-2xl pt-10">{{catalogHeaderText}}</h5>
  </div>
</div>


<div class=" w-full  bg-[#d5d4d9] p-8">
  <h1 class="md:text-4xl  text-2xl font-medium text-black   text-center ">
    Which is the best internet connection for you?
  </h1>
</div>

<section class="md:block hidden">
  <div class="flex justify-center my-16" *ngFor="let item of catalog; let i = index">
    <ng-container *ngIf="i % 2 === 0; else oddItem">
      <!-- Even indexed item, image on the left, text on the right -->
      <div class="flex-row w-1/3 mr-16">
        <h1 class="text-4xl font-medium">{{ item.name }}</h1>
        <p class="text-xl">{{ item.description }}</p>
        <button class="fuse-mat-button-large w-1/3 mt-6 text-lg" mat-flat-button [color]="'accent'"
          [routerLink]='[item.buttonLink]'>
          Learn More
        </button>
      </div>
      <div class="flex-row w-1/4">
        <img [src]="item.image[0].url" alt="{{item.image[0].alternativeText}}" class="rounded-lg" loading="lazy">
      </div>

    </ng-container>
    <ng-template #oddItem>
      <!-- Odd indexed item, text on the left, image on the right -->
      <div class="flex-row w-1/4">
        <img [src]="item.image[0].url" alt="{{item.image[0].alternativeText}}" class="rounded-lg" loading="lazy">
      </div>
      <div class="flex-row w-1/3 ml-16">
        <h1 class="text-4xl font-medium">{{ item.name }}</h1>
        <p class="text-xl">{{ item.description }}</p>
        <button class="fuse-mat-button-large w-1/3 mt-6 text-lg" mat-flat-button [color]="'accent'"
          [routerLink]='[item.buttonLink]'>
          Learn More
        </button>
      </div>
    </ng-template>
  </div>
</section>
<section class="md:hidden block">
  <div class="flex flex-col items-center my-8 mx-8">
    <div *ngFor="let item of catalog; let i = index" class="flex flex-col mb-12">
      <div class="w-full">
        <h1 class="text-4xl font-medium">{{ item.name }}</h1>
        <p class="text-xl">{{ item.description }}</p>
        <button class="fuse-mat-button-large w-1/2 mt-6 text-lg" mat-flat-button [color]="'accent'"
          [routerLink]='[item.buttonLink]'>
          Learn More
        </button>
      </div>
      <div class="w-full mt-10">
        <img [src]="item.image[0].url" alt="{{item.image[0].alternativeText}}" class="rounded-lg" loading="lazy">
      </div>
    </div>
  </div>
</section>



<app-partners></app-partners>